import React from 'react';
import Alert from "../../../components/pages/form/Alert/Alert";

const AlertPage = () => {
    return <Alert />
};

export default AlertPage;
